// sentry
import '../../activeSentry'

//biblioteca
import 'angular-input-masks'

// controllers
import './controlled-pages/login/login-controller'
import './first-steps-pages/welcome-to-idha/welcome-to-idha.component'
import './unregister/unregister.component'
import './therms/therms.component'


// serviços
import './services/LinkActionsService'
import './services/LoginService'

// sdks
import '../sdks/idha-manager-sdk/idha-manager-sdk-min.js'
import '../sdks/idha-orders-sdk/idha-orders-sdk-min.js'
import '../sdks/idha-packing-sdk/idha-packing-sdk-min.js'
import '../sdks/idha-accounts-sdk/idha-accounts-sdk-min.js'

import  './testing/testing.component'

import './verify-email-phone/verifyEmailPhone.component'